<template>
  <span v-if="organizationForDocument.name" class="caption font-weight-bold">
    {{ organizationForDocument.name }} ({{ organizationForDocument.businessId }})
  </span>
</template>
<script>
export default {
  props: {
    document: {
      type: Object,
      default: () => ({}),
    },

    organizations: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    organizationForDocument() {
      if ([
        'TRADE_REGISTER_EXTRACT',
        'MINUTES_EXTRACT',
      ].includes(this.document.documentType)) {
        return this.organizations
          .find(item => item?.organization.businessId
            === this.document.businessId)?.organization || {};
      }

      return {};
    },
  },
};
</script>
